import React, { Suspense } from 'react';

import { isFunction, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

import useModal from 'hooks/useModal';

import { isNonEmptyArray } from 'utils/arrays';

import MODALS from './modals';

const ModalRoot = () => {
  const { modalType, modalProps, stackedModals } = useSelector(
    state => state?.modals,
  );
  const { hideModal: onClose } = useModal();
  const Modal = MODALS[modalType];

  if (!modalType && isEmpty(stackedModals)) {
    return null;
  }

  const onCloseModal = modalProps => {
    if (isFunction(modalProps?.onClose)) {
      modalProps.onClose();
    }
    onClose();
  };

  return (
    <Suspense fallback={<span />}>
      {isNonEmptyArray(stackedModals) ? (
        stackedModals.map(({ modalType, modalProps }) => {
          const StackedModal = MODALS[modalType];
          return (
            <StackedModal
              {...modalProps}
              onClose={() => onCloseModal(modalProps)}
              key={modalType}
            />
          );
        })
      ) : (
        <Modal {...modalProps} onClose={() => onCloseModal(modalProps)} />
      )}
    </Suspense>
  );
};

export default ModalRoot;
